export const isAndroid = (ua) => ua?.includes('Android') ?? false;
export const isIOS = (ua) => ua?.includes('iPhone') || ua?.includes('iPad') || false;
export const isIPad = (ua) => ua?.includes('iPad') ||
    (ua?.includes('Macintosh') && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) ||
    false;
export const isMacOS = (ua) => ua?.includes('Macintosh') || ua?.includes('iPad') || false;
export const isWindowsOS = (ua) => ua?.includes('Windows') ?? false;
export const isLinuxOS = (ua) => (ua?.includes('Linux') && !isAndroid(ua)) ?? false;
//# sourceMappingURL=os.js.map